export interface FAQItem {
  question: string
  answer: string
}

export const FAQS: FAQItem[] = [
  {
    question: 'Is the Independent IT Review really free?',
    answer: 'Yes. The Independent IT Review is completely free. It gives decision-makers an initial view of responsibility, security, continuity and priorities. Any future implementation or managed-service work is separately scoped and only proceeds with your approval.',
  },
  {
    question: 'Do we need to change providers?',
    answer: 'No. The Review can stand on its own and does not force a provider change. CT Group maps the current environment first, then separates urgent risks from later improvements so you retain control of every decision.',
  },
  {
    question: 'What happens in the first conversation?',
    answer: 'A CT Group team member asks what prompted the enquiry, how the firm currently operates and where responsibility feels unclear. No technical access or formal preparation is required for that first discussion.',
  },
  {
    question: 'How does CT Group reduce switching risk?',
    answer: 'Dependencies are mapped before action. Any approved transition is staged around business continuity rather than treated as an automatic rip-and-replace.',
  },
  {
    question: 'Does CT Group understand legal and accounting firms?',
    answer: 'Yes. The service model is designed around professional-services workflows, including practice applications, document processes, client confidentiality, reporting periods and the urgency of fee-earning work.',
  },
  {
    question: 'How is confidential information handled?',
    answer: 'Security and governance are considered from the beginning. The first conversation does not require technical access; any later access, controls and responsibilities are agreed before work starts.',
  },
]
